module.exports = __webpack_public_path__ + "img/没有数据.8cfd0213.png";